import { Checkbox, Column, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from "./ExplicitApproval.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_STATEMENT = 'I have read and agree to the Terms of Service';
export const GetExplicitApprovalTID = prefixTestId => getTestIds(prefixTestId);
export const ExplicitApproval = _ref => {
  let {
    termsOfService,
    onTermsOfServiceChange,
    disabled,
    testid
  } = _ref;
  const {
    ExplicitApprovalTID
  } = GetExplicitApprovalTID(testid);
  const isExplicitApprovalEnabled = (termsOfService === null || termsOfService === void 0 ? void 0 : termsOfService.type) === 'explicitApproval';
  const statement = isExplicitApprovalEnabled ? termsOfService === null || termsOfService === void 0 ? void 0 : termsOfService.explicitApproval.statement : undefined;
  const handleCheckboxChange = e => {
    if (e.target.checked) {
      onTermsOfServiceChange({
        type: 'explicitApproval',
        explicitApproval: {
          statement: DEFAULT_STATEMENT
        }
      });
    } else {
      onTermsOfServiceChange({
        type: 'none'
      });
    }
  };
  const handleStatementChange = e => {
    onTermsOfServiceChange({
      type: 'explicitApproval',
      explicitApproval: {
        statement: e.target.value
      }
    });
  };
  const isDisabled = disabled || !termsOfService;
  return /*#__PURE__*/_jsxs(Column, {
    gap: 12,
    children: [/*#__PURE__*/_jsx(Checkbox, {
      testid: ExplicitApprovalTID.Checkbox(),
      checked: isExplicitApprovalEnabled,
      onChange: handleCheckboxChange,
      disabled: isDisabled,
      label: "Require clients to explicitly approve Terms of Service before signing",
      labelInfo: "When enabled, the client must explicitly confirm that they've read and agreed to the terms by checking a box before signing the agreement."
    }), isExplicitApprovalEnabled && /*#__PURE__*/_jsx(TextField, {
      className: styles.statementInput,
      "data-testid": ExplicitApprovalTID.StatementInput(),
      label: "Checkbox statement",
      value: statement,
      onChange: handleStatementChange,
      disabled: disabled
    })]
  });
};